
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.748 7.073a.75.75 0 10-1.496-.107l1.496.107zm-1.615 12.123l-.748-.054.748.054zm-12.266 0l.748-.054-.748.054zm-.119-12.23a.75.75 0 10-1.496.107l1.496-.107zm5.002 4.065a.75.75 0 00-1.5 0h1.5zm-1.5 6.016a.75.75 0 001.5 0h-1.5zm5.5-6.016a.75.75 0 00-1.5 0h1.5zm-1.5 6.016a.75.75 0 001.5 0h-1.5zm1-10.028a.75.75 0 001.5 0h-1.5zm-6 0a.75.75 0 001.5 0h-1.5zM4 6.27a.75.75 0 000 1.5v-1.5zm16 1.5a.75.75 0 000-1.5v1.5zm-1.748-.803l-.867 12.176 1.496.107.867-12.176-1.496-.107zm-2.114 13.342H7.862v1.5h8.276v-1.5zm-9.523-1.166L5.748 6.966l-1.496.107.867 12.176 1.496-.107zm1.247 1.166c-.654 0-1.2-.507-1.247-1.166l-1.496.107a2.752 2.752 0 002.743 2.56v-1.5zm9.523-1.166a1.252 1.252 0 01-1.247 1.166v1.5c1.444 0 2.64-1.119 2.743-2.559l-1.496-.107zM9.25 11.031v6.016h1.5v-6.016h-1.5zm4 0v6.016h1.5v-6.016h-1.5zM10 3.758h4v-1.5h-4v1.5zm4.25.253V7.02h1.5V4.011h-1.5zM9.75 7.02V4.011h-1.5V7.02h1.5zM14 3.76c.136 0 .25.11.25.252h1.5c0-.966-.781-1.753-1.75-1.753v1.5zm-4-1.5c-.968 0-1.75.786-1.75 1.752h1.5c0-.141.114-.253.25-.253v-1.5zm-6 5.51h16v-1.5H4v1.5z"}})])
          )
        }
      }
    